module.exports = __webpack_public_path__ + "media/images/client-33-ca5824cd1621747634c72f92b670ae22.png";